import { belongsTo, hasMany, Model } from 'miragejs';

export default Model.extend({
  assignedTo: belongsTo({ polymorphic: true }),
  supervisors: hasMany('memberships'),
  exercises: hasMany(),
});
